const initTabs = () => {
  const tabs = document.querySelectorAll("[data-tabs]");
  if (!tabs.length) return;
  tabs.forEach(tab => {
    const buttons = tab.querySelectorAll("[data-tab-button]");
    const cards = tab.querySelectorAll("[data-tab-card]");
  
    buttons.forEach((button, index) => {
      button.addEventListener("click", () => {
        const activeButton = tab.querySelector("[data-tab-button].is-active");
        const activeCard = tab.querySelector("[data-tab-card].is-active");
        activeButton?.classList.remove("is-active");
        activeCard?.classList.remove("is-active");
        button.classList.add("is-active");
        cards[index].classList.add("is-active");
      });
    });
  })
};

export default initTabs;
